import {getRoute} from 'config/navigation';
import {StaticConfig, isProduction} from 'config/staticConfig';

export const getHomeUrl = () => StaticConfig.homePageUrl;
export const getLoginUrl = () => getRoute('/login');
export const getChatBotUrl = () => `${StaticConfig.homePageUrl}/customers/chatbot/chatbot.js`;
export const getChatBotTransciptUrl = () => 'https://www.messenger.stratuscx.com/toolbar.min.js';
export const getChatBotDomainUrl = () => 'https://www.messenger.stratuscx.com';
export const getAppStoreUrl = () => 'https://itunes.apple.com/us/app/amica/id401000907?mt=8';
export const getPlayStoreUrl = () => 'https://play.google.com/store/apps/details?id=com.fivemobile.amica.fnol';
export const getTextVendorTerms = () => 'https://www.himarley.com/sms/';
export const getTextVendorPrivacy = () => 'https://www.himarley.com/privacy-policy/';
export const getTrueCarUrl = () => 'https://amicatl.truecar.com';
export const getPrivacyPolicyURL = () => `${StaticConfig.baseAemApi}/en/privacy-policy.html`;
export const getWebsitePrivacyPolicyURL = () =>
  `${StaticConfig.baseAemApi}/en/privacy-security/website-privacy-policy.html`;
export const getOnlineTermsOfServiceURL = () =>
  `${StaticConfig.baseAemApi}/en/privacy-security/website-terms-of-use.html`;
export const getConservingResourcesURL = () =>
  `${StaticConfig.baseAemApi}/en/about-us/environmental-social-governance/planet.html#ConservingResources`;
export const getLifeQuoteUrl = () => (isProduction ? 'https://termlife.amica.com' : 'https://amica-uat.sureify.com');
